import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { NotificationState } from './notification.state';
import { Observable } from 'rxjs';
import { NotificationModele } from './modeles/notification.modele';
import { OpenModalService } from '../shared/services/open-modal/open-modal.service';
import { NotificationType } from './modeles/notification-type';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: false
})
export class NotificationsComponent implements OnInit {
  @Select(NotificationState.getNotifications)
  notifications$: Observable<NotificationModele[]>;
  notifications: Array<NotificationModele>;

  @Input()
  isDSD = false;

  notificationTypePreautorisation: string = NotificationType.PreautorisationUpdate;

  constructor(private readonly _openModalService: OpenModalService) {}

  ngOnInit() {
    this.notifications$.subscribe((data: NotificationModele[]) => {
      this.notifications = data;
    });
  }
}
